var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMail18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.8 5l5.66 3.652a1 1 0 0 0 1.081.002L15.252 5H2.8zM15 7.552l-4.39 2.792a3 3 0 0 1-3.22 0L3 7.552V12a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7.552zM17 6v6a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3z",
    clipRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTIuOCA1bDUuNjYgMy42NTJhMSAxIDAgMCAwIDEuMDgxLjAwMkwxNS4yNTIgNUgyLjh6TTE1IDcuNTUybC00LjM5IDIuNzkyYTMgMyAwIDAgMS0zLjIyIDBMMyA3LjU1MlYxMmExIDEgMCAwIDAgMSAxaDEwYTEgMSAwIDAgMCAxLTFWNy41NTJ6TTE3IDZ2NmEzIDMgMCAwIDEtMyAzSDRhMyAzIDAgMCAxLTMtM1Y2YTMgMyAwIDAgMSAzLTNoMTBhMyAzIDAgMCAxIDMgM3oiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==";
export { SvgMail18 as ReactComponent };